<script>
    //export let color
    </script>
	<a-entity snow/>
<!-- 
    <a-sky geometry="primitive: sphere" material="shader: threeColorGradientShader; topColor: #88f; middleColor: #fff; bottomColor: #fff;"></a-sky>
 -->
<!-- <a-entity position="0 2.25 -1" particle-system="preset: snow; particleCount: 5000"/> -->
<!-- 	<a-entity environment="preset: starry; groundColor: #FFF; grid: cross;"/> -->
	<!-- <a-entity light="type: ambient;color: #FFF; intensity: 0.6;"/> -->
	<a-entity light="color: #FFF; intensity: 0.9;type:directional; castShadow:true;" position="-1 35 30"/>

<!-- 	<a-circle shadow="receive: true" material="src: #snow; repeat: 20 20" rotation="-90 0 0" radius="100" color="#FFF"/> -->


    <a-sphere material="shader:displacement; transparent: true"
              scale="1000 3 1000"
              radius="0.2"
              position="0 50 -2"
              segments-height="128"
              segments-width="128"></a-sphere>


<!--     <a-entity geometry material={{color}} 
              position="-1 0.5 -3"
              animation="property: rotation; to: 0 360 0; loop: true; easing: linear; " /> -->